export default __webpack_public_path__ + "static/media/deactivate.68dbc675.svg";